import {
  Column,
  ColumnFilterElementTemplateOptions,
  ColumnProps,
} from 'primereact/column';

import { TableDropdownFilter } from '@/components';
import { TableData } from '@/components/Table/types';
import { ValueItem } from '@/types/stockSummary';
import { ColumnGroup } from 'primereact/columngroup';
import { Row } from 'primereact/row';
import { TFunction } from 'i18next';
import {
  filterApplyTemplate,
  filterClearTemplate,
  inputTextTemplate,
} from '@/components/Table/Table';

export const getTableColumns = (): ColumnProps[] => {
  return [
    {
      field: 'tipo',
      header: 'Ti',
      filter: true,
      showFilterMenu: true,
      sortable: true,
      bodyStyle: { background: 'rgba(71, 128, 191, 0.1)' },
    },
    {
      field: 'tamano',
      header: 'Ta',
      filter: true,
      showFilterMenu: true,
      sortable: true,
      bodyStyle: { background: 'rgba(71, 128, 191, 0.1)' },
    },
    {
      field: 'total',
      header: 'Total',
      filter: true,
      showFilterMenu: true,
      style: { fontWeight: 'bold' },
    },
    {
      field: 'fullImport',
      header: 'Importación con ubicación en terminal',
      filter: true,
      showFilterMenu: true,
    },
    {
      field: 'enTransito',
      header: 'En transito',
      filter: true,
      showFilterMenu: true,
    },
    {
      field: 'exportEntregados',
      header: 'En terminal sin buque de salida',
      filter: true,
      showFilterMenu: true,
    },
    {
      field: 'exportacionTransito',
      header: 'En terminal sin buque de salida',
      filter: true,
      showFilterMenu: true,
    },
    {
      field: 'reposicionVaciosOK',
      header: 'Vacios OK',
      filter: true,
      showFilterMenu: true,
    },
    {
      field: 'vaciosDisponibles',
      header: 'Vacios',
      filter: true,
      showFilterMenu: true,
    },
  ];
};

export const getHeaderColumnsGroup = (
  translates: TFunction<'stockSummary', undefined>,
  data: ValueItem[] | undefined
) => (
  <ColumnGroup>
    <Row>
      <Column
        header={translates('tableHeadings.type')}
        field="tipo"
        rowSpan={3}
        sortable
        style={{ borderTopLeftRadius: '16px' }}
        showFilterMenu
        filter
        showFilterMatchModes={false}
        filterApply={filterApplyTemplate}
        filterClear={filterClearTemplate}
        filterElement={(options: ColumnFilterElementTemplateOptions) => (
          <TableDropdownFilter
            options={options}
            data={data as TableData}
            fieldName="tipo"
          />
        )}
      />
      <Column
        header={translates('tableHeadings.size')}
        field="tamano"
        rowSpan={3}
        sortable
        showFilterMenu
        filter
        showFilterMatchModes={false}
        filterApply={filterApplyTemplate}
        filterClear={filterClearTemplate}
        filterElement={(options: ColumnFilterElementTemplateOptions) => (
          <TableDropdownFilter
            options={options}
            data={data as TableData}
            fieldName="tamano"
          />
        )}
      />
      <Column
        header={translates('tableHeadings.total')}
        field="total"
        rowSpan={3}
        sortable
        showFilterMenu
        filter
        showFilterMatchModes={false}
        filterApply={filterApplyTemplate}
        filterElement={inputTextTemplate}
        filterClear={filterClearTemplate}
      />
      <Column
        header={translates('tableHeadings.fullImport')}
        field="fullImport"
        rowSpan={3}
        headerStyle={{ textWrap: 'wrap' }}
        sortable
        showFilterMenu
        filter
        style={{ borderTop: 'solid 5px var(--highlight-color)' }}
        showFilterMatchModes={false}
        filterApply={filterApplyTemplate}
        filterElement={inputTextTemplate}
        filterClear={filterClearTemplate}
      />
      <Column
        header={translates('tableHeadings.inTransit')}
        field="enTransito"
        rowSpan={3}
        headerStyle={{ textWrap: 'wrap' }}
        sortable
        showFilterMenu
        filter
        showFilterMatchModes={false}
        filterApply={filterApplyTemplate}
        filterClear={filterClearTemplate}
        style={{ borderTop: 'solid 5px var(--success-color)' }}
      />
    </Row>
    <Row>
      <Column
        header={translates('tableHeadings.export')}
        colSpan={2}
        style={{ borderTop: 'solid 5px var(--main-color)' }}
      />
      <Column
        header={translates('tableHeadings.reposicionExport')}
        colSpan={2}
        style={{
          borderTopRightRadius: '16px',
          borderTop: 'solid 5px var(--danger-color)',
        }}
      />
    </Row>
    <Row>
      <Column
        header={translates('tableHeadings.delivered')}
        field="exportEntregados"
        sortable
        showFilterMenu
        filter
        headerStyle={{ textWrap: 'wrap' }}
        showFilterMatchModes={false}
        filterApply={filterApplyTemplate}
        filterElement={inputTextTemplate}
        filterClear={filterClearTemplate}
      />
      <Column
        header={translates('tableHeadings.transitExport')}
        field="exportacionTransito"
        sortable
        showFilterMenu
        headerStyle={{ textWrap: 'wrap' }}
        filter
        showFilterMatchModes={false}
        filterApply={filterApplyTemplate}
        filterElement={inputTextTemplate}
        filterClear={filterClearTemplate}
      />
      <Column
        header={translates('tableHeadings.emptyOk')}
        field="reposicionVaciosOK"
        sortable
        showFilterMenu
        headerStyle={{ textWrap: 'wrap' }}
        filter
        showFilterMatchModes={false}
        filterApply={filterApplyTemplate}
        filterElement={inputTextTemplate}
        filterClear={filterClearTemplate}
      />
      <Column
        header={translates('tableHeadings.empty')}
        field="vaciosDisponibles"
        sortable
        showFilterMenu
        headerStyle={{ textWrap: 'wrap' }}
        filter
        showFilterMatchModes={false}
        filterApply={filterApplyTemplate}
        filterElement={inputTextTemplate}
        filterClear={filterClearTemplate}
      />
    </Row>
  </ColumnGroup>
);
